import { RequestConstant } from '../constants';

export const request = (type, payload, toast) => ({
  payload,
  subtype: type,
  toast: typeof toast === 'boolean' ? toast : true,
  type: RequestConstant.REQUEST,
});
